import { RegionType } from '@wix/shoutout-email-model-v3';
import * as cssUtils from '../../utils/css-utils';
export const getHtmlSection = ({ region, css, }) => {
    if (region.type !== RegionType.Html) {
        throw Error('Html must be passed');
    }
    const rules = [css['so-global-region']];
    const mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    return {
        html: region.data.html,
        cssClass: mobileCssClass,
    };
};
//# sourceMappingURL=get-html-section.js.map